var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.popShow)?_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"top_notification"},[_vm._v(_vm._s(_vm.popText))])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7315372c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alert.vue
// module id = 508
// module chunks = 1